<div class="buttons-container">
  <app-action-button *ngFor="let button of buttonsList" [color]="button.style" [icon]="button.icon" [text]="button.text" (clickEvent)="handleActionClick(button.action)"></app-action-button>
</div>